import { useFieldArray } from "react-hook-form";

const AddonsForm = ({ t, control, register, errors, addonCategories,lang }) => {
  const { fields, append, remove } = useFieldArray({
    control,
    name: "addons",
  });
  // Add new addon
  const handleAdd = () => {
    append({
      addOnCategoryId: "",
      name: "",
      nameEn: "",
      price: "",
      stock: "",
    });
  };

  return (
    <div className="my-card mt-3">
      <div className="my-card-header text-primary">{t("addons")}</div>
      <div className="my-card-body">
        {fields?.map((addon, index) => (
          <div className="my-card mt-3" key={index}>
            <div className="row">
              <div className="col-12 col-md-6">
                <div className="form-group">
                  <label className="form-label">{t("addonCategory")}</label>
                  <select
                    {...register(`addons.${index}.addOnCategoryId`)}
                    className="form-control"
                  >
                    <option value="">--{t("addonCategory")}--</option>
                    {addonCategories?.map((item) => (
                      <option key={item.id} value={item.id}>
                        {item.name[lang]}
                      </option>
                    ))}
                  </select>
                  <p className="text-danger">
                    {errors?.addons?.[index]?.addonCategoryId?.message}
                  </p>
                </div>
              </div>
              <div className="col-12 col-md-6">
                <div className="form-group">
                  <label className="form-label">{t("name")}</label>
                  <input
                    type="text"
                    {...register(`addons.${index}.name`)}
                    className="form-control"
                    placeholder={t("name")}
                  />
                  <p className="text-danger">
                    {errors?.addons?.[index]?.name?.message}
                  </p>
                </div>
              </div>
              <div className="col-12 col-md-6">
                <div className="form-group">
                  <label className="form-label">{t("nameEn")}</label>
                  <input
                    type="text"
                    {...register(`addons.${index}.nameEn`)}
                    className="form-control"
                    placeholder={t("nameEn")}
                  />
                  <p className="text-danger">
                    {errors?.addons?.[index]?.nameEn?.message}
                  </p>
                </div>
              </div>
              <div className="col-12 col-md-6">
                <div className="form-group">
                  <label className="form-label">{t("price")}</label>
                  <input
                    type="number"
                    {...register(`addons.${index}.price`)}
                    className="form-control"
                    placeholder={t("price")}
                  />
                  <p className="text-danger">
                    {errors?.addons?.[index]?.price?.message}
                  </p>
                </div>
              </div>
              <div className="col-12 col-md-6">
                <div className="form-group">
                  <label className="form-label">{t("stock")}</label>
                  <input
                    type="number"
                    {...register(`addons.${index}.stock`)}
                    className="form-control"
                    placeholder={t("stock")}
                  />
                  <p className="text-danger">
                    {errors?.addons?.[index]?.stock?.message}
                  </p>
                </div>
              </div>
            </div>
          </div>
        ))}
        {fields.length > 0 && (
          <div
            className="remove-btn mt-3"
            onClick={() => remove(fields.length - 1)}
          >
            <i className="fas fa-minus plus-icon"></i> {t("remove")}
          </div>
        )}
        <div className="add-btn mt-3" onClick={handleAdd}>
          <i className="fas fa-plus plus-icon"></i> {t("add")}
        </div>
      </div>
    </div>
  );
};
export default AddonsForm;
